$('.switch').click(function () {
    if ($(this).attr('data-switch') == 'off') {
        $(this).attr('data-switch', 'on');
        $(this).addClass('switch_on');
        $(this).removeClass('switch_off');
        $(this).find('span').text('on');
    } else {
        $(this).attr('data-switch', 'off');
        $(this).addClass('switch_off');
        $(this).removeClass('switch_on');
        $(this).find('span').text('off');
    }
})